<div class="custom-dropdown" (clickOutside)="closeDropdown()">
    <div class="custom-dropdown-section">
        <button id="dropDownButton" [ngClass]="{disableDropdown: isDisabled, 'error-section' : showError
    , 'btnHeight': buttonHeight}"
            [disabled]="isDisabled" class="custom-dropdown-button" (click)="toggleOnSelect()">
            <span class="wrapText">{{selectText}}</span>
            <i class="fa fa-caret-down dropdown-icon"></i>
        </button>
        <div class="custom-dropdown-section-content" id="dropOptionSection">
            <a *ngFor="let option of options" (click)="selectOption(option)"
                [ngClass]="{disableDropdown: option.isDisabled}" [title]="option.showToolTip ? inputTooltip : ''">
                {{option.value}}
                <span *ngIf="option.showToolTip" offset="0" theme="light" autoPlacement="true" 
                    zIndex="20000" placement="bottom" class="info-icon mr-2">
                    <i class="fas fa-info-circle"></i>
                </span>
            </a>
        </div>
    </div>
</div>
